import Button, { ButtonProps } from 'atoms/Button';
import Link from 'atoms/NextLink';
import cn from 'classnames';
import React from 'react';

import s from './LinkButton.module.scss';

interface LinkButtonProps extends ButtonProps {
  href: string;
  target?: string;
  children?: React.ReactNode;
  className?: string;
  classNameInner?: string;
}

const LinkButton = ({
  href,
  target,
  children,
  className,
  classNameInner,
  ...rest
}: LinkButtonProps) => (
  <Link href={href}>
    <a className={cn(s.LinkButton, className)} target={target}>
      <Button {...rest} className={cn(s.LinkButtonInner, classNameInner)}>
        {children}
      </Button>
    </a>
  </Link>
);

export default LinkButton;
